<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item :to="{ path: '/fengxian'}">风险管控</el-breadcrumb-item>
						  
						  <el-breadcrumb-item v-if="tuwen_type == 61">风险管控理论</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="tuwen_type == 63">风险管控工具</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="tuwen_type == 65">风险管控案例</el-breadcrumb-item>
						  
						</el-breadcrumb>
					</div>
					
					<div class="nrqy">
						
						<el-row class="tiaojian_elrow" style="margin-top: -10px;">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按类别：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" @click="clickTag(0, 0)" :type="list_tags_type[0]">不限</el-tag>
									<el-tag type="info" size="small" v-for="(item, index) in list_tags" :key="index" :type="list_tags_type[index+1]" @click="clickTag(index+1, item.id)">{{item.keyword}}</el-tag>
								</div>
							</el-col>
						</el-row>

						<el-row class="tiaojian_elrow" style="border: 0px;">
							<el-col :span="21" :push="1">
								<div class="tiaojian_line_row_right">
									<el-input
										placeholder="请输入关键词搜索..."
										prefix-icon="el-icon-search"
										style="width: 40%;"
										v-model="keyword"
										:clearable="true"
										@clear="clearInput"
										>
									</el-input>
									<el-button type="primary" size="medium" @click="doSearch" v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
									<span class="span_search_result">检索到{{total}}条数据</span>
								</div>
							</el-col>
						</el-row>
						
					</div>
					
					<div class="neirong_line">
						<div class="neirong_line_left">
							
							<el-empty description="没找到你想要的数据..." v-show="is_show_empty"></el-empty>
							
							<div class="neirong_line_region" v-for="(item, index) in list_record">
								<div class="neirong_line_title" @click="toUrl('/detail_article?p=list_fengxian&t='+tuwen_type+'&id='+item.id)">
									<div class="neirong_line_title_icon"></div>{{item.title}}
								</div>
								<div class="neirong_line_summary">
									{{item.summary}}
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							
							<div class="neirong_line_page">
								<el-pagination
								  background
								  layout="prev, pager, next, jumper"
								  :page-size="7"
								  :total="total"
								  @current-change="handlePage"
								  >
								</el-pagination>
							</div>
							
						</div>
						
						
						<div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div>
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
		},
		data() {
			return {
				tuwen_type: 0,
				list_tags: [],
				list_tags_type: ['primary', ],
				is_show_empty: false,
				tag_id: 0, // 标签id
				keyword: '', // 搜索关键词
				list_record: [], // 数据列表
				pi: 1, // 当前页码
				total: 0, //数据总数
				tag_id: 0,
				
				fullscreenLoading: false,
				
				
			}
		},
		
		created() {
			this.tuwen_type = this.$route.query.t // 获取URL参数赋值
			this.tag_id = this.$route.query.tgid // 类别tagsid
			
			let trigger = this.$route.query.trigger
			// console.log(trigger)
			if (trigger == 'sch') {
				this.keyword = this.$route.query.kw
			}
			
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadTags()
			this.doSearch()
		},
		
		watch: {
			// 监听路由变化
			$route(to, from) {
				if (to.fullPath != from.fullPath) {
					// location.reload()
					this.$router.go(0)
				}
			}
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			
			// 加载该图文类别下的标签关键词列表
			loadTags() {
				let url = this.$common.apiUrl + 'pub_keyword_ipofile/listByType/' + this.tuwen_type
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_tags = res.data.data
					// 绑定样式数组
					this.list_tags.forEach((item, index) => {
						this.list_tags_type.push('info')
					})
					
					// 如果有传参则默认选中在查询
					if (this.tag_id > 0) {
						this.clickTagAuto(this.tag_id)
					}
				})
			},
			
			// 点击筛选标签
			clickTag(index, tagid) {
				console.log(index + '|' + tagid);
				this.list_tags_type.forEach((item, idx) => {
					if (index == idx) {
						this.$set(this.list_tags_type, idx, 'primary')
					} else {
						this.$set(this.list_tags_type, idx, 'info')
					}
				})
				this.pi = 1
				this.tag_id = tagid
				this.doSearch()
			},
			
			// 加载搜索数据
			doSearch() {
				this.fullscreenLoading = true
				this.list_record = [] // 先设置成空有个视觉切换效果
				let url = this.$common.apiUrl + 'pub_tuwen_base/clientSearch'
				let client_data = this.$qs.stringify({title: this.keyword, keywords: [this.tag_id], dictTuwenType: this.tuwen_type, pi: this.pi})
				this.$axios.post(url, client_data).then((res)=>{
					console.log(res.data)
					this.fullscreenLoading = false
					this.list_record = res.data.data.rows
					this.total = res.data.data.total
					if (this.list_record == 0) {
						this.is_show_empty = true
					} else {
						this.is_show_empty = false
					}
				})
			},
			
			// 清空搜索框时
			clearInput() {
				if (this.keyword == '') {
					this.pi = 1
					this.doSearch()
				}
			},
			
			// 点击分页触发事件
			handlePage(page) {
				// console.log(page)
				this.pi = page
				this.doSearch()
				document.documentElement.scrollTop = 0;
			},
			
			// 默认点击标签，传参数显示选中标签，按类别位置
			clickTagAuto(tagid) {
				let index = 0;
				this.list_tags.forEach((item, idx) => {
					if (item.id == tagid) {
						index = idx + 1
					}
				})
				console.log(index + '|' + tagid);
				this.clickTag(index, tagid);
			},
			
			
			
		}
	}
</script>

<style scoped>
.el-dropdown-link {
	cursor: pointer;
	color: #409EFF;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.el-tag--small {
	margin: 0 10px;
}
.el-dropdown {
	margin: 0 10px;
}
</style>